import React from 'react'

function ColumnWrapper(props) {

    return (
        <div className="columns">
            {props.children}
        </div>
    );

}

export default ColumnWrapper



/** WEBPACK FOOTER **
 ** ./src/components/ColumnWrapper.js
 **/